import { render, staticRenderFns } from "./CollectionEditForm.vue?vue&type=template&id=0336f0fe&scoped=true"
import script from "./CollectionEditForm.vue?vue&type=script&lang=js"
export * from "./CollectionEditForm.vue?vue&type=script&lang=js"
import style0 from "./CollectionEditForm.vue?vue&type=style&index=0&id=0336f0fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0336f0fe",
  null
  
)

export default component.exports